'use client';

import { c as _c } from "react/compiler-runtime";
import type { GetStudentMentoringStateOutputDTO } from '@algoacademy/backend/modules/payment/endpoints/queries/get-student-mentoring-state/output.dto';
import { Link } from '@algoacademy/design-system/web/actions/Link';
import { DarkCard } from '@algoacademy/design-system/web/data-display/Card';
import { P3 } from '@algoacademy/design-system/web/typography/Paragraph';
import { formatDiscountSummary } from '../../_helpers/mentoring-terms';
type NoActiveSubscriptionNoticeProps = {
  unpaidOffer: GetStudentMentoringStateOutputDTO['unpaidOffer'];
};

/**
 * Lookup finished and nobody is on a live subscription. Staff still needs a
 * clear answer - silence reads like the e-mail was wrong or the check failed.
 */
export function NoActiveSubscriptionNotice(t0) {
  const $ = _c(8);
  const {
    unpaidOffer
  } = t0;
  if (unpaidOffer === null) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <DarkCard role="status" className="p-3"><P3 className="text-contentSecondary">Brak aktywnej subskrypcji mentoringu dla podanego adresu.</P3></DarkCard>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== unpaidOffer.discount) {
    t1 = unpaidOffer.discount === null ? null : formatDiscountSummary(unpaidOffer.discount);
    $[1] = unpaidOffer.discount;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const discountSummary = t1;
  let t2;
  if ($[3] !== unpaidOffer.offerUrl) {
    t2 = <Link href={unpaidOffer.offerUrl} target="_blank" rel="noreferrer" className="text-algoprimary underline">nieopłaconą ofertę</Link>;
    $[3] = unpaidOffer.offerUrl;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = discountSummary === null ? "." : ` (${discountSummary}).`;
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <DarkCard role="status" className="p-3"><P3 className="text-contentSecondary">Brak aktywnej subskrypcji dla podanego adresu. Uczeń ma już{" "}{t2}{t3} Wystawienie nowej oferty zastąpi ją warunkami wybranymi powyżej.</P3></DarkCard>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}